import React, { useState } from "react";
import ReceptionistLayout from "../../Layouts/Receptionist/ReceptionistLayout";

export default function ReceptionistBilling() {
    const [formData, setFormData] = useState({
        patientName: "",
        consultationFee: "",
        additionalCharges: "",
    });

    const recentBills = [
        {
            billId: "#B101",
            patient: "Ravi Kumar",
            amount: "₹1500",
            status: "Paid",
        },
        {
            billId: "#B102",
            patient: "Meena",
            amount: "₹1200",
            status: "Pending",
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "paid":
                return "badge badge-light-success text-success fw-bold px-3 py-2 rounded-pill";
            case "pending":
                return "badge badge-light-danger text-danger fw-bold px-3 py-2 rounded-pill";
            default:
                return "badge badge-light-secondary text-secondary fw-bold px-3 py-2 rounded-pill";
        }
    };

    return (
        <ReceptionistLayout>
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <h3 className="fw-bold text-dark mb-5">Create New Bill</h3>

                            <form onSubmit={handleSubmit}>
                                <div className="row g-4">
                                    <div className="col-12 col-md-6">
                                        <label className="form-label fw-semibold mb-1">
                                            Patient Name
                                        </label>
                                        <input
                                            type="text"
                                            name="patientName"
                                            className="form-control"
                                            value={formData.patientName}
                                            onChange={handleChange}
                                            placeholder="Enter patient name"
                                        />
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="form-label fw-semibold mb-1">
                                            Consultation Fee
                                        </label>
                                        <input
                                            type="text"
                                            name="consultationFee"
                                            className="form-control"
                                            value={formData.consultationFee}
                                            onChange={handleChange}
                                            placeholder="Enter consultation fee"
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label fw-semibold mb-1">
                                            Additional Charges
                                        </label>
                                        <input
                                            type="text"
                                            name="additionalCharges"
                                            className="form-control"
                                            value={formData.additionalCharges}
                                            onChange={handleChange}
                                            placeholder="Enter additional charges"
                                        />
                                    </div>

                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100 btn-sm fw-bold py-3 rounded-3"
                                        >
                                            Generate Bill
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="card border rounded-4 shadow-sm">
                        <div className="card-body p-4 p-lg-5">
                            <h3 className="fw-bold text-dark mb-5">Recent Bills</h3>

                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed mb-0">
                                    <thead>
                                        <tr className="fw-bold text-dark border-bottom">
                                            <th>Bill ID</th>
                                            <th>Patient</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody className="fw-semibold text-gray-700">
                                        {recentBills.map((item) => (
                                            <tr key={item.billId}>
                                                <td>{item.billId}</td>
                                                <td>{item.patient}</td>
                                                <td>{item.amount}</td>
                                                <td>
                                                    <span className={getStatusBadge(item.status)}>
                                                        {item.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}

                                        {recentBills.length === 0 && (
                                            <tr>
                                                <td colSpan="4" className="text-center py-10 text-muted fw-semibold">
                                                    No bills found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReceptionistLayout>
    );
}
